import React from 'react';
import PropTypes from 'prop-types';

import { RulesSection, RulesHeading, RulesList } from "./styles";

const PlanRules = ({ rules }) => (
  <RulesSection>
    <RulesHeading>Plan rules</RulesHeading>
    <RulesList dangerouslySetInnerHTML={{ __html: rules }} />
  </RulesSection>
);

PlanRules.propTypes = {
  rules: PropTypes.string,
};

export default PlanRules;
